import { BlockConnectorCandidatesResponse } from './types'

type Candidate = BlockConnectorCandidatesResponse['data'][number]

export function generateCandidateId(
  blockId: string,
  viewId: string | null,
  categoryId: string | null
) {
  return [blockId, viewId, categoryId].filter((key) => !!key).join(':')
}

export function findConnectionCandidate(
  candidates: Array<Candidate>,
  candidateId: string
): Candidate | undefined {
  let candidate: (typeof candidates)[number] | undefined = undefined

  for (const c of candidates) {
    if (
      generateCandidateId(
        c.block.id,
        c.supportive_view_id,
        c.supportive_category_id
      ) === candidateId
    ) {
      candidate = c
      break
    }

    if (c.child_candidates) {
      candidate = findConnectionCandidate(
        c.child_candidates as Array<Candidate>,
        candidateId
      )
      if (candidate) break
    }
  }
  return candidate
}

export function findCandidateBySupportiveCategory(
  candidates: Array<Candidate>,
  supportiveCategoryId: string
): Candidate | undefined {
  let candidate: (typeof candidates)[number] | undefined = undefined

  for (const c of candidates) {
    if (
      generateCandidateId(
        c.block.id,
        c.supportive_view_id,
        c.supportive_category_id
      ).endsWith(supportiveCategoryId)
    ) {
      candidate = c
      break
    }

    if (c.child_candidates) {
      candidate = findCandidateBySupportiveCategory(
        c.child_candidates as Array<Candidate>,
        supportiveCategoryId
      )
      if (candidate) break
    }
  }
  return candidate
}
